var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Mangopay bank account resources take a moment to propagate after creation.
// Requesting a mandate for a bank account too soon after creating it returns
// this specific param_error, which resolves itself once the resource is ready.
//
// The backend currently forwards this as `{ message: <raw Mangopay error> }`
// (Mangopay errors use a capitalized `Message`, so the backend's own
// `err.message || err` fallback ends up nesting the whole error body one
// level deeper, under `message`, instead of at the top level). Check both
// shapes so this keeps working whether or not that gets straightened out
// backend-side later.
var extractMangopayErrorBody = function (error) {
    var _a;
    var data = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data;
    if (!data) {
        return undefined;
    }
    if (data.Type || data.errors) {
        return data;
    }
    if (data.message && typeof data.message === "object") {
        return data.message;
    }
    return undefined;
};
export var isBankAccountNotYetValidError = function (error) {
    var _a;
    var body = extractMangopayErrorBody(error);
    return (body === null || body === void 0 ? void 0 : body.Type) === "param_error" && !!((_a = body === null || body === void 0 ? void 0 : body.errors) === null || _a === void 0 ? void 0 : _a.BankAccountId);
};
var delay = function (ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
};
export var retryWithBackoff = function (fn_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([fn_1], args_1, true), void 0, function (fn, options) {
        var _a, delaysMs, _b, shouldRetry, attempt, unknownError_1, isLastAttempt;
        if (options === void 0) { options = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = options.delaysMs, delaysMs = _a === void 0 ? [500, 1000, 2000] : _a, _b = options.shouldRetry, shouldRetry = _b === void 0 ? function () { return true; } : _b;
                    attempt = 0;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, fn()];
                case 2: return [2 /*return*/, _c.sent()];
                case 3:
                    unknownError_1 = _c.sent();
                    isLastAttempt = attempt >= delaysMs.length;
                    if (isLastAttempt || !shouldRetry(unknownError_1)) {
                        throw unknownError_1;
                    }
                    return [4 /*yield*/, delay(delaysMs[attempt])];
                case 4:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 5:
                    attempt++;
                    return [3 /*break*/, 1];
                case 6: return [2 /*return*/];
            }
        });
    });
};
